import React, {useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import mime from 'mime-types';
import FilePreview from '../../../../FilePreview';
import AnimatedUploadingFilePopUp from '../../../../AnimatedUploadingFilePopUp';
import ButtonCommon from "../../../../ButtonCommon";
import download from '../../../../../assets/download-24px 1.svg';
import {getFullDataURI} from "../../../../../utils/files/getFullDataURI";
import {downloadFile} from "../../../../../utils/files/downloadFile";
import styles from './styles.module.scss';

export function FileItem({
                           shumaID,
                           fileID,
                           fileName,
                           fileTypeName,
                           fileExtension,
                           showGlobalErrorMessage,
                           getFile,
                         }) {
  const [content, setContent] = useState(false);
  const [fileType, setFileType] = useState(null);
  const [loading, setLoading] = useState(false);
  const [previewIsOpen, setPreviewIsOpen] = useState(false);
  const openPreview = () => setPreviewIsOpen(true);
  const closePreview = () => setPreviewIsOpen(false);

  const updateFile = async () => {
    setFileType(null);
    setContent(null);
    const body = await getFile({shumaId: shumaID, fileID});
    const mimeType = mime.lookup(fileExtension);
    const dataUri = `data:${mimeType};base64,${body}`;
    setContent(dataUri);
    setFileType(getType());

    return dataUri;
  };

  const handleFileOpen = () => {
    if (getType()) {
      Promise.resolve()
        .then(() => setLoading(true))
        .then(() => setFileType('spinner'))
        .then(updateFile)
        .then(() => openPreview())
        .catch((e) => {
          setFileType(null);
          showGlobalErrorMessage(e.message);
          closePreview();
        })
        .finally(() => setLoading(false));
    }
  };

  const handleDownload = () => {
    Promise.resolve()
      .then(() => setLoading(true))
      .then(() => {
        return getFile({shumaId: shumaID, fileID})
      })
      .then(content => {
        const dataURI = getFullDataURI({body: content, file_extension: 'pdf'});
        downloadFile(dataURI, fileName);
      })
      .catch(error => showGlobalErrorMessage(error.message))
      .finally(() => setLoading(false))
  };

  useEffect(() => {
    setFileType(getType());
  }, [fileID]);

  const getType = () => {
    switch (mime.lookup(fileExtension)) {
      case 'application/pdf':
        return 'pdf';
      case 'image/gif':
      case 'image/jpeg':
      case 'image/jpg':
      case 'image/tiff':
      case 'image/png':
        return 'image';
      default:
        return null;
    }
  };

  return (
    <>
      <div
        key={fileID}
        className={styles.filesListContainer}
      >
        <div className={styles.name}>
          <span
            dir="ltr"
            onClick={() => handleFileOpen()}
          >
            {fileName}
          </span>
        </div>
        <div className={styles.type}>
          {fileTypeName}
        </div>
        <div className={styles.button}>
          <ButtonCommon
            icon={download}
            customContainerStyles={styles.buttonDownload}
            onClick={() => handleDownload()}
          />
        </div>
      </div>
      <AnimatedUploadingFilePopUp show={loading}/>
      <FilePreview
        isOpen={previewIsOpen}
        close={closePreview}
        dataURI={content}
        type={fileType}
      />
    </>
  );
}

FileItem.propTypes = {
  shumaID: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  fileID: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  fileName: PropTypes.string,
  fileTypeName: PropTypes.string,
  fileExtension: PropTypes.string,
  showGlobalErrorMessage: PropTypes.func,
  getFile: PropTypes.func,
};
